/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequestErrorDto,
  ConflictErrorDto,
  EmailDto,
  EmailStatusResponse,
  InternalErrorDto,
} from '../models/index';
import {
    BadRequestErrorDtoFromJSON,
    BadRequestErrorDtoToJSON,
    ConflictErrorDtoFromJSON,
    ConflictErrorDtoToJSON,
    EmailDtoFromJSON,
    EmailDtoToJSON,
    EmailStatusResponseFromJSON,
    EmailStatusResponseToJSON,
    InternalErrorDtoFromJSON,
    InternalErrorDtoToJSON,
} from '../models/index';

export interface CheckEmailStatusRequest {
    email: string;
}

export interface RetryVerificationEmailRequest {
    emailDto: EmailDto;
}

export interface SendVerificationEmailRequest {
    emailDto: EmailDto;
}

export interface VerifyUserEmailRequest {
    token: string;
}

/**
 * 
 */
export class EmailApi extends runtime.BaseAPI {

    /**
     * Check the verification status of the specified email address
     * Check if email is verified
     */
    async checkEmailStatusRaw(requestParameters: CheckEmailStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailStatusResponse>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling checkEmailStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/email/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailStatusResponseFromJSON(jsonValue));
    }

    /**
     * Check the verification status of the specified email address
     * Check if email is verified
     */
    async checkEmailStatus(requestParameters: CheckEmailStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailStatusResponse> {
        const response = await this.checkEmailStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend the email verification link to the specified email address if the previous attempt failed or expired
     * Send a retry attempt to send the verification email
     */
    async retryVerificationEmailRaw(requestParameters: RetryVerificationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['emailDto'] == null) {
            throw new runtime.RequiredError(
                'emailDto',
                'Required parameter "emailDto" was null or undefined when calling retryVerificationEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/email/retry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailDtoToJSON(requestParameters['emailDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resend the email verification link to the specified email address if the previous attempt failed or expired
     * Send a retry attempt to send the verification email
     */
    async retryVerificationEmail(requestParameters: RetryVerificationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.retryVerificationEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a verification email to the user\'s email address to verify ownership
     * Send verification email
     */
    async sendVerificationEmailRaw(requestParameters: SendVerificationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['emailDto'] == null) {
            throw new runtime.RequiredError(
                'emailDto',
                'Required parameter "emailDto" was null or undefined when calling sendVerificationEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/email/verify`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailDtoToJSON(requestParameters['emailDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send a verification email to the user\'s email address to verify ownership
     * Send verification email
     */
    async sendVerificationEmail(requestParameters: SendVerificationEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.sendVerificationEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify the user\'s email address using the provided verification token
     * Verify user email
     */
    async verifyUserEmailRaw(requestParameters: VerifyUserEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling verifyUserEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/email/verify/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Verify the user\'s email address using the provided verification token
     * Verify user email
     */
    async verifyUserEmail(requestParameters: VerifyUserEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.verifyUserEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
